export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Deny.vue`
      ),
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Error.vue`
      ),
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      ),
  },
  {
    path: '/primeiro-acesso',
    meta: { breadcrumb: true, auth: true },
    name: 'Welcome',
    title: 'Bem-vindo',
    component: () => import(`@/views/welcome/Welcome.vue`),
  },
  {
    path: '/alertas',
    meta: { breadcrumb: true, auth: true },
    name: 'Alerts',
    title: 'Notificações',
    component: () => import(`@/views/alerts/Alerts.vue`),
  },
  {
    path: '/cadastrar',
    meta: {
      public: true,
    },
    name: 'Cadastrar',
    component: () => import(`@/views/Signup.vue`),
  },
  {
    path: '/alterar-senha',
    meta: {
      public: true,
    },
    name: 'ResetPassword',
    component: () => import(`@/views/ResetPassword.vue`),
  },
  {
    path: '/ajuda',
    meta: {
      public: true,
    },
    name: 'Help',
    component: () => import(`@/views/help/Help.vue`),
  },
  {
    path: '/alterar-senha/:token',
    meta: {
      public: true,
    },
    name: 'ResetPasswordToken',
    component: () => import(`@/views/ResetPassword.vue`),
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    title: 'Home',
    redirect: {
      name: 'Dashboard',
    },
  },
  {
    path: '/dashboard',
    meta: { breadcrumb: true, auth: true },
    title: 'Home',
    name: 'Dashboard',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dashboard.vue`
      ),
  },
  {
    path: '/noticias',
    meta: { breadcrumb: true, auth: true },
    title: 'Notícias',
    name: 'News',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/News.vue`
      ),
  },
  {
    path: '/romaneios',
    meta: { breadcrumb: true, auth: true },
    name: 'RomaneioIndex',
    title: 'Romaneios',
    component: () => import(`@/views/romaneio/RomaneioIndex.vue`),
  },
  {
    path: '/acessos',
    meta: { breadcrumb: true, auth: true },
    name: 'ExplorerAccess',
    title: 'Permitir acesso ao Romaneio',
    component: () => import(`@/views/romaneio/ExplorerAccess.vue`),
  },
  {
    path: '/acessos-token',
    meta: { breadcrumb: true, auth: true },
    name: 'AccessToken',
    title: 'Acesso a romaneio com token',
    component: () => import(`@/views/romaneio/AccessToken.vue`),
  },
  {
    path: '/romaneios/:id',
    meta: { breadcrumb: true, auth: true },
    name: 'Romaneio',
    title: 'Romaneio',
    component: () => import(`@/views/romaneio/Romaneio.vue`),
  },
  {
    path: '/romaneios/images/:id',
    meta: { breadcrumb: true, auth: true },
    name: 'RomaneioImage',
    title: 'Romaneio imagens',
    component: () => import(`@/views/romaneio/RomaneioImages.vue`),
  },
  {
    path: '/propriedades',
    meta: { breadcrumb: true, auth: true },
    name: 'PropertyIndex',
    title: 'Propriedades',
    component: () => import(`@/views/property/PropertyIndex.vue`),
  },
  {
    path: '/propriedades/:id',
    meta: { breadcrumb: true, auth: true },
    name: 'PropertyEdit',
    title: 'Editar Propriedade',
    component: () => import(`@/views/property/PropertyEdit.vue`),
  },
  {
    path: '/produtores',
    meta: { breadcrumb: true, auth: true },
    name: 'Explorer',
    title: 'Produtores',
    component: () => import(`@/views/explorer/ExplorerIndex.vue`),
  },

  {
    path: '/feedback',
    meta: { breadcrumb: false, auth: true },
    name: 'Feedback',
    title: 'Feedback',
    component: () => import(`@/views/feedback/Feedback.vue`),
  },

  {
    path: '/perfil',
    meta: { breadcrumb: false, auth: true },
    name: 'Profile',
    title: 'Perfil',
    component: () => import(`@/views/profile/Profile.vue`),
  },

  {
    path: '/reastreabilidade',
    meta: {
      public: true,
    },
    name: 'Track',
    component: () => import(`@/views/track/Track.vue`),
  },

  {
    path: '/abate-ao-vivo',
    meta: { breadcrumb: false, auth: true },
    name: 'AbateOnline',
    title: 'Abate Ao Vivo',
    component: () => import(`@/views/AbateAoVivo/AbateAoVivo.vue`),
  },

  {
    path: '/termos-de-uso-e-servico',
    meta: {
      public: true,
    },
    name: 'TermsOfUse',
    component: () => import(`@/components/help/TermsOfUse.vue`),
  },

  {
    path: '/apps/tracebeef',
    meta: {
      public: true,
    },
    beforeEnter(to, from, next) {
      if (to.query.os == 'android') {
        window.location =
          'https://play.google.com/store/apps/details?id=solutions.ecotrace.tracebeef&hl=pt-BR';
      } else if (to.query.os == 'ios') {
        window.location =
          'https://apps.apple.com/br/app/trace-beef/id1473856584';
        console.log(to, from);
      } else {
        window.location = '/';
      }
    },
  },

  {
    path: '/emails-mkt/',
    meta: { public: true },
    name: 'PublicAlertPreferences',
    title: 'Preferencias de envio de e-mail',
    component: () => import(`@/views/alerts/PublicAlertPreferences`),
  },

  {
    path: '/relatorio-romaneio-pdf',
    meta: { public: true },
    name: 'RelatorioRomaneioDownload',
    title: 'Relatório Romaneio',
    component: () => import(`@/views/alerts/RelatorioRomaneioDownload`),
  },
];
